export default {
    "ui:layout": "section",
    "messages": {
        "items": {
            "ui:layout": "module"
        }
    }
}